import { render, staticRenderFns } from "./articleDetail.vue?vue&type=template&id=d6df8f46&scoped=true"
import script from "./articleDetail.vue?vue&type=script&lang=js"
export * from "./articleDetail.vue?vue&type=script&lang=js"
import style0 from "./articleDetail.vue?vue&type=style&index=0&id=d6df8f46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6df8f46",
  null
  
)

export default component.exports